import { render, staticRenderFns } from "./ChoicePeriodField.vue?vue&type=template&id=5cc9780a"
import script from "./ChoicePeriodField.vue?vue&type=script&lang=ts"
export * from "./ChoicePeriodField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports